import * as React from 'react';
import {Switch, Route, withRouter} from 'react-router-dom';
// @ts-expect-error
import type {ContextRouter} from 'react-router-dom';

import {Routing} from 'nutshell-core/routing';

import {RestrictedRoute} from '../../../routes/shared/restricted-route';

import {BoardOnboarding} from '../onboarding/board-onboarding/board-onboarding';

import {LeadLayoutCustomizer} from './lead-layout-customizer/lead-layout-customizer';
import {SalesAutomationClosedLeads} from './sales-automation-closed-leads';
import {SalesAutomationOpenLeads} from './sales-automation-open-leads';

const ONBOARDING_DELAY = 2500;
const ONBOARD_PARAM = 'onboard';
const HELP_PARAM = 'help';

type State = {
    shouldShowPostWizardOnboarding: boolean;
    shouldShowOnboarding: boolean;
};

type Props = ContextRouter;

/*
 * Root component in our Sales Automation tree. This component
 * is responsible for saving/cancelling out of the entire app.
 *
 * It'll use the route to determine which child component to render
 */
class SalesAutomationAppComponent extends React.PureComponent<Props, State> {
    onboardTimeoutId: number | null | undefined;

    constructor() {
        // @ts-expect-error
        super();
        this.state = {
            shouldShowPostWizardOnboarding: false,
            shouldShowOnboarding: false,
        };
    }

    componentDidMount() {
        // If param is found, show the onboarding after a short delay
        const params = Routing.deparam(this.props.location.search.replace(/^\?/, ''));
        if (params[ONBOARD_PARAM]) {
            // @ts-expect-error
            this.onboardTimeoutId = setTimeout(() => {
                this.setState({shouldShowPostWizardOnboarding: true});
            }, ONBOARDING_DELAY);
        }

        if (
            (params[HELP_PARAM] ||
                // @ts-expect-error
                window.NutClientConfig.shouldShowSalesAutomationPipelineOnboarding) &&
            !this.props.location.pathname.includes('/customize-layout')
        ) {
            // @ts-expect-error
            this.onboardTimeoutId = setTimeout(() => {
                this.setState({shouldShowOnboarding: true});
            }, ONBOARDING_DELAY);
        }
    }

    UNSAFE_componentWillReceiveProps(nextProps: Props) {
        // Stop showing onboarding modal if the param disappears
        const params = Routing.deparam(this.props.location.search.replace(/^\?/, ''));
        const nextParams = Routing.deparam(nextProps.location.search.replace(/^\?/, ''));
        if (params[ONBOARD_PARAM] && !nextParams[ONBOARD_PARAM]) {
            this.setState({shouldShowPostWizardOnboarding: false});
        }
        if (params[HELP_PARAM] && !nextParams[HELP_PARAM]) {
            this.setState({shouldShowOnboarding: false});
        }
    }

    componentWillUnmount() {
        // Clear the onboarding timeout if the component is closed
        if (this.onboardTimeoutId) {
            clearTimeout(this.onboardTimeoutId);
        }
    }

    getBasePath() {
        return '/sales/pipelines/:stagesetId';
    }

    render() {
        return (
            <React.Fragment>
                <Switch location={this.props.location}>
                    <RestrictedRoute
                        path={`${this.getBasePath()}/customize-layout`}
                        render={(routeProps) => {
                            return (
                                <LeadLayoutCustomizer
                                    stagesetId={routeProps.match.params.stagesetId || '1-stagesets'}
                                />
                            );
                        }}
                        hasAccess={NutClientConfig.hasLeadPageRedesignM3FF}
                        redirectPath='/sales/pipelines'
                    />
                    <Route
                        path={`${this.getBasePath()}/closed-leads`}
                        render={(props) => (
                            <SalesAutomationClosedLeads
                                // @ts-expect-error
                                stagesetId={props.match.params.stagesetId}
                            />
                        )}
                    />
                    <Route
                        exact={true}
                        path={`${this.getBasePath()}`}
                        render={() => <SalesAutomationOpenLeads />}
                    />
                </Switch>
                {this.state.shouldShowPostWizardOnboarding ? (
                    <BoardOnboarding
                        shouldShowWelcome={true}
                        onClose={this.handleOnboardingClose}
                    />
                ) : null}
                {this.state.shouldShowOnboarding ? (
                    <BoardOnboarding
                        shouldShowWelcome={false}
                        onClose={this.handleOnboardingClose}
                    />
                ) : null}
            </React.Fragment>
        );
    }

    handleOnboardingClose = () => {
        this.setState({
            shouldShowOnboarding: false,
            shouldShowPostWizardOnboarding: false,
        });

        // Prevent showing the onboarding again before a full page change
        // @ts-expect-error
        window.NutClientConfig.shouldShowSalesAutomationPipelineOnboarding = false;

        this.props.history.replace(this.props.location.pathname);
    };
}

// @ts-expect-error
export const SalesAutomationApp = withRouter<Record<any, any>>(SalesAutomationAppComponent);
